import { SeedOrderApiRecord, SeedOrderStatus } from 'modules/domain/seedOrders/types'
import { apiClient } from 'modules/utils/httpClient'
import { endpoints } from 'modules/endpoints'
import { ListResponse } from 'types/api'

export const createSeedOrder = (body: Record<string, unknown>) =>
  apiClient.post<SeedOrderApiRecord>(endpoints.seedOrders(), body)

export const getSeedOrder = (id: string) => apiClient.get<SeedOrderApiRecord>(endpoints.seedOrders(id))

export const updateSeedOrder = (id: string, body: Record<string, unknown>) =>
  apiClient.put<SeedOrderApiRecord>(endpoints.seedOrders(id), body)

export const updateSeedOrderStatus = (id: string, orderStatus: SeedOrderStatus) =>
  apiClient.put<SeedOrderApiRecord>(`${endpoints.seedOrders(id)}/status`, { order_status: orderStatus })

export const deleteSeedOrder = (id: string) => apiClient.delete(endpoints.seedOrders(id))

export type ListSeedOrdersParams = {
  search?: string
  page?: number
  page_size?: number
  product_card_id?: string
  origin_company_id?: string
  destination_company_id?: string
  order_status?: string
  current_pedigree?: string
  sort_field?: string
  sort_reversed?: boolean
}

export const listSeedOrders = (params: ListSeedOrdersParams = {}) =>
  apiClient.get<ListResponse<SeedOrderApiRecord>>(endpoints.seedOrders(), {
    page: params.page ?? 1,
    page_size: params.page_size ?? 50,
    ...(params.search != null && params.search !== '' ? { search: params.search } : {}),
    ...(params.product_card_id != null ? { product_card_id: params.product_card_id } : {}),
    ...(params.origin_company_id != null ? { origin_company_id: params.origin_company_id } : {}),
    ...(params.destination_company_id != null ? { destination_company_id: params.destination_company_id } : {}),
    ...(params.order_status != null ? { order_status: params.order_status } : {}),
    ...(params.current_pedigree != null ? { current_pedigree: params.current_pedigree } : {}),
    ...(params.sort_field != null ? { sort_field: params.sort_field } : {}),
    ...(params.sort_reversed != null ? { sort_reversed: params.sort_reversed } : {}),
  })
